import React, { useEffect, useState, useRef } from 'react';
import { ContenedorFecha, Formulario, Input, InputGrande, ContenedorBoton, ContenedorDayPicker } from './../elementos/ElementosDeFormulario';
import Boton from '../elementos/Boton';
import { ReactComponent as IconoAgregar } from './../imagenes/plus.svg';
import { fromUnixTime } from 'date-fns';
import getUnixTime from 'date-fns/getUnixTime';
import { useAuth } from '../contextos/AuthContext';
import Alerta from './../elementos/Alerta';
import { useNavigate } from 'react-router-dom';
// IMPORTANTE
import editarIngreso from '../firebase/editarIngreso';
import agregarIngreso from './../firebase/agregarIngreso';
// Day Picker
import { DayPicker } from 'react-day-picker';
import { format, isValid, parse } from 'date-fns';
import FocusTrap from 'focus-trap-react';
import { usePopper } from 'react-popper';
import 'react-day-picker/dist/style.css';
import es from 'date-fns/locale/es';

const FormularioIngreso = ({gasto: ingreso}) => {

    const navigate = useNavigate();

    // Estados de los inputs
    const [inputDescripcion, cambiarInputDescripcion] = useState('');
    const [inputCantidad, cambiarInputCantidad] = useState('');

    // Estado para cambiar la fecha
    const [selectedDay, setSelectedDay] = useState(new Date());

    // Creamos las constantes de las fechas
    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',];
    const dias_semana_cortos = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];

    // Funciones de la nueva actualización
    const [inputValue, setInputValue] = useState('');
    const [isPopperOpen, setIsPopperOpen] = useState(false);

    const popperRef = useRef(null);
    const buttonRef = useRef(null);
    const [popperElement, setPopperElement] = useState(null);

    const popper = usePopper(popperRef.current, popperElement, {
        placement: 'bottom-center'
    });

    const closePopper = () => {
        setIsPopperOpen(false);
        buttonRef?.current?.focus();
    };

    const handleInputChange = (e) => {
        setInputValue(e.currentTarget.value);
        const date = parse(e.currentTarget.value, 'y-MM-dd', new Date());
        if (isValid(date)) {
            setSelectedDay(date);
        } else {
            setSelectedDay(undefined);
        }
    };

    const handleButtonClick = () => {
        setIsPopperOpen(true);
    };

    const handleDaySelect = (date) => {
        setSelectedDay(date);
        if (date) {
            setInputValue(format(date, 'y-MM-dd'));
            closePopper();
        } else {
            setInputValue('');
        }
    };

    // Constante para sacar el usuario
    const {usuario} = useAuth();

    // Creamos un estado para la alerta
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const [alerta, cambiarAlerta] = useState({});

    useEffect(() => {
        // Comprobamos si ya hay algún gasto
        // De ser así establecemos todo el state con los valores del gasto
        if(ingreso) {
            // Comprobamos que el gasto sea del usuario actual
            // Para eso comprobamos el uid guardado en el gasto con el uid del usuario
            if (ingreso.data().uidUsuario === usuario.uid) {
                setSelectedDay(fromUnixTime(ingreso.data().fecha));
                setInputValue(format(fromUnixTime(ingreso.data().fecha), 'y-MM-dd'));
                cambiarInputDescripcion(ingreso.data().descripcion);
                cambiarInputCantidad(ingreso.data().cantidad);
            } else {
                navigate('/lista');
            }
        }
    }, [ingreso, usuario, navigate]);

    // Creamos función para el cambio de valores en los inputs
    const handleChange = (e) => {
        if(e.target.name === 'descripcion') {
            cambiarInputDescripcion(e.target.value);
        } else if (e.target.name === 'cantidad') {
            cambiarInputCantidad(e.target.value.replace(/[^0-9.]/g, ''));
        }
    }

    // Función para cuando se envía el formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        const cantidad = parseFloat(inputCantidad).toFixed(2);
 
        // Comprobamos que haya una descripción y valor
        if(inputDescripcion !== '' && inputCantidad !== '' && selectedDay !== '') {

            if (cantidad) {
                // Le pasamos nuestros valores a la función agregarGasto, que es la que guarda los valores en FIREBASE
                if(ingreso) {
                    // console.log('La fecha es:', getUnixTime(fecha));
                    
                    // Esto es una promesa
                    editarIngreso({
                        id: ingreso.id,
                        descripcion: inputDescripcion,
                        cantidad: cantidad,
                        fecha: getUnixTime(selectedDay)
                    }).then(() => {
                        navigate('/lista-de-ingresos');
                    }).catch((error) => {
                        console.log(error);
                    });

                } else {
                    agregarIngreso({
                        descripcion: inputDescripcion,
                        cantidad: cantidad,
                        fecha: getUnixTime(selectedDay),
                        uidUsuario: usuario.uid
                    })
                    .then(() => {
                        cambiarInputDescripcion('');
                        cambiarInputCantidad('');
                        setSelectedDay(new Date());
    
                        cambiarEstadoAlerta(true);
                        cambiarAlerta({
                            tipo: 'exito',
                            mensaje: 'El ingreso fue agregado correctamente!'
                        });
                    })
                    .catch((error) => {
                        cambiarEstadoAlerta(true);
                        cambiarAlerta({
                            tipo: 'error',
                            mensaje: 'Error al intentar agregar tu ingreso'
                        });
                        console.log(error);
                        console.log(inputDescripcion);
                        console.log(cantidad);
                        console.log(getUnixTime(selectedDay));
                        console.log(usuario.uid);
                    });
                }
                
            } else {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: 'El valor que ingresaste no es ingreso'
                });
            }

        } else {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los campos'
            });
        }
    }

    return (  
        <Formulario onSubmit={handleSubmit}>
            <ContenedorFecha>
                {/* <DayPicker fecha={fecha} cambiarFecha={cambiarFecha} /> */}
                <ContenedorDayPicker>
                    <input
                        type="text"
                        placeholder={format(new Date(), 'y-MM-dd')}
                        value={inputValue}
                        onChange={handleInputChange}
                        className="input-daypicker"
                    />
                    <button
                        ref={buttonRef}
                        type="button"
                        className="button-daypicker"
                        aria-label="Pick a date"
                        onClick={handleButtonClick}
                        >
                        <span role="img" aria-label="calendar icon" className='calendar-icon'>
                            📅
                        </span>
                    </button>
                    {isPopperOpen && (
                        <FocusTrap
                            active
                            focusTrapOptions={{
                                initialFocus: false,
                                allowOutsideClick: true,
                                clickOutsideDeactivates: true,
                                onDeactivate: closePopper
                            }}
                        >
                            <div
                                tabIndex={10}
                                style={{position: 'absolute', top: '200px', right: '100px'}}
                                className="dialog-sheet"
                                {...popper.attributes.popper}
                                ref={setPopperElement}
                                role="dialog"
                            >
                                <DayPicker
                                    initialFocus={isPopperOpen}
                                    mode="single"
                                    selected={selectedDay}
                                    onSelect={handleDaySelect}
                                    dayPickerProps={
                                        {
                                            months: meses,
                                            weekdaysShort: dias_semana_cortos
                                        }
                                    }
                                    locale={es}
                                />
                            </div>
                        </FocusTrap>
                    )}
                </ContenedorDayPicker>
            </ContenedorFecha>

            <div>
                <Input 
                    type='text'
                    name='descripcion'
                    id='descripcion'
                    placeholder='Descripción del ingreso'
                    value={inputDescripcion}
                    onChange={ handleChange }
                />

                <InputGrande 
                    type='text'
                    name='cantidad'
                    id='cantidad'
                    placeholder='$0.00'
                    value={inputCantidad}
                    onChange={ handleChange }
                />

                <ContenedorBoton>
                    { ingreso 
                        ? 
                            <Boton as='button' primario type='submit'>
                                Editar ingreso
                            </Boton>
                        : 
                            <Boton as='button' primario conIcono type='submit'>
                                Agregar ingreso
                                <IconoAgregar/>
                            </Boton>
                    }            
                </ContenedorBoton>
            </div>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={cambiarEstadoAlerta}
            />
        </Formulario>
    );
}
 
export default FormularioIngreso;